import { connect } from 'react-redux';

import CommentEditor from './CommentEditor';

export default connect(({ discussion: { usersById, teamsByName } }) => ({
  usersById,
  teamsByName,
}))(CommentEditor);
